// Методы для помощи экспорта в эксель
export const routeGetParamChangeOnFly = {
    methods: {
        routeGetParamChangeOnFly(params) {
            history.pushState(
                {},
                null,
                this.$route.path +
                '?' +
                Object.keys(params)
                    .map(key => {
                        return (
                            encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
                        )
                    })
                    .join('&')
            )
        },
    }
}



